import { Component, input, output } from '@angular/core';


export type Direction = 'asc' | 'desc';

export type HeaderState = Direction | 'inactive';


@Component({
    selector: 'table-header',
    styles: [
        `
        @media screen, print {
            :host {
                display: flex;
                user-select: none;
                justify-content: space-between;
            }
            label {
                width: 100%;
                margin: 0;
                text-overflow: ellipsis;
                overflow-x: hidden;
            }
            .arrows {
                color: lightblue;
            }
            .arrows i {
                display: block;
                line-height: .6;
            }
            .arrows .active {
                color: orange;
            }
        }
        @media print {
            .arrows {
                display: none !important;
            }
        }
        `
    ],
    template: `
        <label [class]="sortable() ? ['cursor-pointer', 'text-primary', 'active'] : null" (click)="doSort()">
            <ng-content></ng-content>
        </label>
        @if (orderByState() !== 'inactive') {
            <div class="d-flex flex-column justify-content-center ml-1 arrows">
                <i [class.active]="orderByState() === 'desc'" class="fa fa-caret-up"></i>
                <i [class.active]="orderByState() === 'asc'" class="fa fa-caret-down"></i>
            </div>
        }
    `,
})
export class TableHeaderComponent {

    sortable = input(true);

    orderByState = input<HeaderState>();

    sort = output<Direction>();

    doSort() {
        if (!this.sortable()) {
            return;
        }
        this.sort.emit(this.orderByState() !== 'asc' ? 'asc' : 'desc');
    }
}
